// Home.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import GlassBox from '../GlassBox/GlassBox';
import AccessibilityPanel from '../AccessibilityPanel/AccessibilityPanel';
import homeImg from '../../assets/home_img.png';

const Home = () => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Preload the background image
    const img = new Image();
    img.src = homeImg;
    img.onload = () => setImageLoaded(true);
    
    // Set loaded immediately to prevent flash
    setImageLoaded(true);
  }, []);

  return (
    <div className={`HomeImg ${imageLoaded ? 'image-loaded' : 'image-loaded'}`}>
      <GlassBox onLoginClick={() => navigate('/login')} />
      <AccessibilityPanel />
    </div>
  );
};

export default Home;
